import { render, staticRenderFns } from "./EventDetailsComponent.vue?vue&type=template&id=68ed5436&scoped=true"
import script from "./EventDetailsComponent.vue?vue&type=script&lang=js"
export * from "./EventDetailsComponent.vue?vue&type=script&lang=js"
import style0 from "./EventDetailsComponent.vue?vue&type=style&index=0&id=68ed5436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ed5436",
  null
  
)

export default component.exports